
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resumes",
      function () {
        return require("private-next-pages/resumes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resumes"])
      });
    }
  